define('components/tags/entityTag/viewmodel',
    [
        'viewmodels/base_es5',
        'components/tags/entityTag/model',
        './template.html',
        './styles.scss'
    ],

    function (Base, Model) {
        components.preload('wcc-list', 'tag');

        function ViewModel(config) {
            Base.call(this, config);

            this.labels = labels;

            this.manager = this.model.manager;
            this.allowEdit = this.manager.pluck('allowEdit', false);
            this.allowRemove = this.manager.pluck('allowRemove', false);

            this.tag = this.model.tag;
            this.tagId = this.tag.pluck('contentTagId');
            this.visibility = this.tag.pluck('visibility');

            this.visibilityOptions = _(enums.ContentTagVisibilityType).toArray();
        }

        ViewModel.Model = Model;

        ViewModel.prototype = Object.create(Base.prototype);
        ViewModel.prototype.costructor = ViewModel;

        ViewModel.prototype.edit = function () {
            this.manager.invokeNotNull('editTag', this.tag());
        };

        ViewModel.prototype.remove = function () {
            this.manager.invokeNotNull('removeTag', this.tag());
        };

        ViewModel.prototype.setVisibility = function (visibility) {
            this.manager.invokeNotNull(function (manager) {
                var data = _(this.tag().toJson()).extend({
                    Visibility: visibility
                });

                manager.updateTag(data);
            }, this);
        };

        ViewModel.prototype.beforeInit = function () {
            Base.prototype.beforeInit.call(this);

            ko.applyBindingsToNode(this.element, {
                'css': {
                    'entity-tag': true
                }
            });
        };

        return ViewModel;
    });